// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#024d98","secondaryColor":"#565656"};